import { render, staticRenderFns } from "./TravelInsured.vue?vue&type=template&id=0131eccf&"
import script from "./TravelInsured.vue?vue&type=script&lang=js&"
export * from "./TravelInsured.vue?vue&type=script&lang=js&"
import style0 from "./TravelInsured.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelInsured.vue"
export default component.exports